import React from "react";

const GradientGlowDivider = ({
  className = "",
  glowIntensity = "blur-[0.5px]",
  thickness = "h-[1px]",
}) => {
  return (
    <div className={`relative w-full ${thickness} ${className}`}>
      {/* Base line with responsive gradient */}
      <div
        className={`absolute inset-0 w-full ${thickness} bg-gradient-to-r from-transparent via-white to-transparent opacity-40`}
      />

      {/* Responsive glowing effect */}
      <div
        className={`absolute inset-0 w-full ${thickness} bg-gradient-to-r from-gray-800 via-white to-gray-800 opacity-60 ${glowIntensity}`}
      />
    </div>
  );
};

export default GradientGlowDivider;
